<div class="footer">
    <div class="">
        <span style="float: right">Version - {{ appVersion }}</span>
    </div>
</div>
